module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5X3K1"))).then(() => parcelRequire('5erN3'));